/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankIdCreateLoginPayloadResponse
 */
export interface BankIdCreateLoginPayloadResponse {
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    cipher: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    tag: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    nonce: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    issuedAt: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    expiresAt: string;
}

/**
 * Check if a given object implements the BankIdCreateLoginPayloadResponse interface.
 */
export function instanceOfBankIdCreateLoginPayloadResponse(value: object): value is BankIdCreateLoginPayloadResponse {
    if (!('cipher' in value) || value['cipher'] === undefined) return false;
    if (!('tag' in value) || value['tag'] === undefined) return false;
    if (!('nonce' in value) || value['nonce'] === undefined) return false;
    if (!('issuedAt' in value) || value['issuedAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function BankIdCreateLoginPayloadResponseFromJSON(json: any): BankIdCreateLoginPayloadResponse {
    return BankIdCreateLoginPayloadResponseFromJSONTyped(json, false);
}

export function BankIdCreateLoginPayloadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankIdCreateLoginPayloadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cipher': json['cipher'],
        'tag': json['tag'],
        'nonce': json['nonce'],
        'issuedAt': json['issuedAt'],
        'expiresAt': json['expiresAt'],
    };
}

export function BankIdCreateLoginPayloadResponseToJSON(json: any): BankIdCreateLoginPayloadResponse {
    return BankIdCreateLoginPayloadResponseToJSONTyped(json, false);
}

export function BankIdCreateLoginPayloadResponseToJSONTyped(value?: BankIdCreateLoginPayloadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cipher': value['cipher'],
        'tag': value['tag'],
        'nonce': value['nonce'],
        'issuedAt': value['issuedAt'],
        'expiresAt': value['expiresAt'],
    };
}

